module.exports = __webpack_public_path__ + "img/Eduzz-8-es.af9e63df.png";